module.exports = __webpack_public_path__ + "img/blog-55.ceb363f2.jpg";